const searchRestrictions = () => {
    let search = document.getElementById('search-product');
    if(!search){
        return;
    }
    document.getElementById('search-product').addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            if (this.value.trim().length < 3) {
                e.preventDefault();
            }
        }
    });
};

export default searchRestrictions;
